<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th v-for="heading in content.head" :key="heading" v-html="heading" />
        </tr>
      </thead>
      <tbody>
        <tr v-for="body in content.bodyRegular" :key="body">
          <td v-html="body[0]" />
          <td v-for="i in body.slice(1, 4)" :key="i"><img :src="i" /></td>
        </tr>
        <tr v-for="body in content.bodyLight" :key="body">
          <td class="light" v-html="body[0]" />
          <td v-for="i in body.slice(1, 4)" :key="i">

            <p class="table-text" v-if="setAsString(i)">{{ i }}</p>
            <img v-else :src="i" />

          </td>
        </tr>
        <tr class="price">
          <!-- <td v-for="prices in content.price" :key="prices" v-html="prices" /> -->
          <td v-html="content.price[0]" />
          <td><Button class="table-button" :link="'mailto:info+edu@eyejackapp.com'">{{content.price[1]}}</Button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Button from './Button.vue'
export default {
  name: "Table",
  props: ["content"],
  components: {
    Button,
  },

  setup(props) {
    console.log(props.content.body);
    const setAsString = (i) => {
      if (i.startsWith('Unlimited')) {
        return true
      }
    }

    return {
      setAsString
    };
  },
};
</script>

<style lang="scss" >
@import "../styles/styles.scss";
.light {
  font-weight: 300;
}
.bold {
  font-weight: 700;
}
table {
  font-size: 1em;
  width: 80%;
  margin: auto;
  border-collapse: collapse;
  overflow: hidden;
  border: solid 2px #f4f4f4;
  font-weight: 400;
  filter: drop-shadow(0px 8px 20px rgba(0, 0, 0, 0.1));
  border-radius: 8px;
  tr {
    text-align: center;
  }
  thead {
    background: #0d0d0d;
    color: #fff;
    tr {
      th {
        border-left: solid 2px #f4f4f4;
        border-right: solid 2px #f4f4f4;
        font-size: 1.375em;
        font-weight: 400;
        height: 80px;
        // width: 283px;
      }
      h2 {
        font-size: 1.625rem;
        font-weight: 700;
        color: #fff;
      }
      .subHead {
        font-size: 1.25rem;
        font-weight: 400;
      }
    }
  }
  tbody {
    tr {
      td {
        background: #f4f4f4;
        // width: 283px;
        // max-width: 452px;
        width: 300px;
        height: 4em;
        border-left: solid 2px #f4f4f4;
        border-right: solid 2px #f4f4f4;
        font-size: 1.25em;
        letter-spacing: 1.2px;
        padding: 0 1em;
        .table-text {
          font-size:1.25rem;
        }
      }
      td:nth-child(3) {
        background: #f4f4f4;
      }
      td + td {
        background: #fff;
        // width: 283px;
      }
      img {
        width: 28.08px;
        height: 18.17px;
      }
      .sub-views {
        font-style: italic;
        font-size: 0.8em;
      }
    }
  }
}
.price {
  font-weight: 500;
  td {
    padding-top: 10px;

    font-size: 1.625em;
    position: relative;
    .table-button {
      // margin: auto;
      font-size: 1rem !important;
      font-weight: 400;
      margin: 2em auto 1.5em auto;
      // width: 100%;
      // height: 
    }
      padding: 0;
    p {
      font-size: 0.535em;
      color: #0d0d0d;
    }
    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 10px;
      left: 20%;
      margin: 0 auto;
      width: 60%;
      border-top: 1px solid #e9e6e6;
    }
  }
}

@include media("<desktop-md", ">=tablet") {
  .table {
    font-size: 1.2vw;
    thead {
      tr {
        h2 {
          font-size: 2vw;
        }
        .subHead {
          font-size: 1.5vw;
        }
      }
    }
    tbody {
      tr {
        img {
          width: 2.3vw;
          height: 1.8vw;
        }
      }
    }
  }
}
</style>